import { AbstractControl, ValidatorFn } from '@angular/forms';

const PATTERN = /^([1-9]+([0-9]+)?|0)(.[0-9]{1,2})?$/;
const regex = new RegExp(PATTERN);

export function priceValidator(): ValidatorFn {
  return (control: AbstractControl) => {
    if ([null, undefined, ''].includes(control?.value)) {
      return null;
    }

    const valueToCheck = control.value.toString();
    return regex.test(valueToCheck) ? null : { price: true };
  };
}
